var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout-header",
    [
      _c(
        "q-toolbar",
        { staticClass: "mobile-hide no-shadow", style: _vm.getStyleDesktop },
        [
          _c("q-toolbar-title", [
            _vm._v("\n\t\t\t" + _vm._s(_vm.$t("control_panel")) + "\n\t\t")
          ]),
          _vm.showHomeButton
            ? _c("q-btn", {
                staticClass: "q-mr-md",
                attrs: {
                  flat: "",
                  dense: "",
                  label: _vm.$t("home"),
                  icon: "fas fa-home"
                },
                on: {
                  click: function($event) {
                    return _vm.goToHome()
                  }
                }
              })
            : _vm._e(),
          !_vm.showHomeButton
            ? _c("q-btn", {
                staticClass: "q-mr-md",
                attrs: {
                  flat: "",
                  dense: "",
                  label: _vm.$t("home"),
                  icon: "fas fa-home"
                },
                on: {
                  click: function($event) {
                    return _vm.goToHomeV2()
                  }
                }
              })
            : _vm._e(),
          _c("client"),
          _c("country"),
          _c("notification"),
          _c("user-menu"),
          _c("language")
        ],
        1
      ),
      _c(
        "q-toolbar",
        { staticClass: "desktop-hide", style: _vm.getStyleMobile },
        [
          _c("q-btn", {
            attrs: { flat: "", round: "", dense: "", icon: "fas fa-bars" },
            on: {
              click: function($event) {
                return _vm.openMenu()
              }
            }
          }),
          _c("q-toolbar-title", [
            _vm._v("\n\t\t\t" + _vm._s(_vm.$t("control_panel")) + "\n\t\t")
          ]),
          _c("notification")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }